import styled from 'styled-components';
import { HeadingExtraBoldS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const GroupCont = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.centy};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
  `}
`;

export const SliderHeader = styled.div`
  width: 100%;

  ${({ theme }: IThemeProvider) => `
    height: ${theme.layout.spacing.giga};
    padding: 24px 18px 20px 18px;
  `}
`;

export const HeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
`;
